import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import type { Lab } from "../../features/CourseBuilder/components/LabsTab/types";

export interface LabState {
	labs: Lab[];
	isLoading: boolean;
	error: string | null;
	currentPage: number;
	totalPages: number;
	totalItems: number;
}

const initialState: LabState = {
	labs: [],
	isLoading: false,
	error: null,
	currentPage: 1,
	totalPages: 1,
	totalItems: 0,
};

const labSlice = createSlice({
	name: "lab",
	initialState,
	reducers: {
		setLabs: (state, action: PayloadAction<Lab[]>) => {
			state.labs = action.payload;
		},
		addLab: (state, action: PayloadAction<Lab>) => {
			const index = state.labs.findIndex(lab => lab.id === action.payload.id);
			if (index !== -1) {
				state.labs[index] = action.payload;
			} else {
				state.labs.unshift(action.payload);
			}
		},
		updateLab: (state, action: PayloadAction<Lab>) => {
			const index = state.labs.findIndex(lab => lab.id === action.payload.id);
			if (index !== -1) {
				state.labs[index] = action.payload;
			}
		},
		removeLab: (state, action: PayloadAction<number>) => {
			state.labs = state.labs.filter(lab => lab.id !== action.payload);
		},
		setLoading: (state, action: PayloadAction<boolean>) => {
			state.isLoading = action.payload;
		},
		setError: (state, action: PayloadAction<string | null>) => {
			state.error = action.payload;
		},
		setPagination: (state, action: PayloadAction<{ page: number; totalPages: number; totalItems: number }>) => {
			state.currentPage = action.payload.page;
			state.totalPages = action.payload.totalPages;
			state.totalItems = action.payload.totalItems;
		},
		clearLabs: state => {
			state.labs = [];
		},
	},
});

export const { setLabs, addLab, updateLab, removeLab, setLoading, setError, setPagination, clearLabs } =
	labSlice.actions;
export default labSlice.reducer;
